class ClientLogger {
  constructor() {
    this.logQueue = [];
    this.isProcessing = false;
    this.maxQueueSize = 100;
    this.retryCount = 0;
    this.maxRetries = 3;
    this.retryDelay = 5000; // 5 seconds
    this.apiUrl = process.env.REACT_APP_API_URL || window.location.origin;
  }

  async log(level, message, metadata = {}) {
    const timestamp = new Date().toISOString();
    const logEntry = {
      timestamp,
      level,
      message,
      metadata,
    };

    this.logQueue.push(logEntry);

    if (this.logQueue.length >= this.maxQueueSize) {
      await this.processQueue();
    }
  }

  async processQueue() {
    if (this.isProcessing || this.logQueue.length === 0) return;

    this.isProcessing = true;
    const logs = [...this.logQueue];
    this.logQueue = [];

    try {
      const response = await fetch(`${this.apiUrl}/api/logs`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(logs),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      this.retryCount = 0; // Reset retry count on success
    } catch (error) {
      // Only log to console in development
      if (process.env.NODE_ENV === "development") {
        console.error("Failed to send logs:", error);
      }

      // Retry logic
      if (this.retryCount < this.maxRetries) {
        this.retryCount++;
        setTimeout(() => {
          this.isProcessing = false;
          this.processQueue();
        }, this.retryDelay * this.retryCount);
      } else {
        // If max retries reached, clear the queue
        this.logQueue = [];
        this.isProcessing = false;
        this.retryCount = 0;
      }
    }
  }

  info(message, metadata = {}) {
    return this.log("info", message, metadata);
  }

  warn(message, metadata = {}) {
    return this.log("warn", message, metadata);
  }

  error(message, metadata = {}) {
    return this.log("error", message, metadata);
  }

  debug(message, metadata = {}) {
    return this.log("debug", message, metadata);
  }
}

export const logger = new ClientLogger();

// Process queue periodically, but only in production
if (process.env.NODE_ENV === "production") {
  setInterval(() => {
    logger.processQueue();
  }, 5000);
}
